if (!customElements.get('p4m-helmet-model-browser')) {
  const P4M_HELMET_MODEL_RULES = {
    'agv-helmets': [
      ['pista-gp-rr', 'Pista GP RR', [/\bpista\s+gp\s+rr\b/]],
      ['streetmodular', 'Streetmodular', [/\bstreetmodular\b/]],
      ['tourmodular', 'Tourmodular', [/\btourmodular\b/]],
      ['sportmodular', 'Sportmodular', [/\bsportmodular\b/]],
      ['ax9', 'AX9', [/\bax\s*9\b/]],
      ['k1-s', 'K1 S', [/\bk\s*1\s+s\b/]],
      ['k3', 'K3', [/\bk\s*3\b/]],
      ['k5-s', 'K5 S', [/\bk\s*5\s+s\b/]],
      ['k6-s', 'K6 S', [/\bk\s*6\s+s\b/]],
      ['k7', 'K7', [/\bk\s*7\b/]]
    ],
    'arai-helmets': [
      ['classic-v', 'Classic-V', [/\bclassic\s*v\b/]],
      ['contour-x', 'Contour-X', [/\bcontour\s*x\b/]],
      ['corsair-x', 'Corsair-X', [/\bcorsair\s*x\b/]],
      ['defiant-x', 'Defiant-X', [/\bdefiant\s*x\b/]],
      ['quantum-x', 'Quantum-X', [/\bquantum\s*x\b/]],
      ['ram-x', 'Ram-X', [/\bram\s*x\b/]],
      ['regent-x', 'Regent-X', [/\bregent\s*x\b/]],
      ['signet-x', 'Signet-X', [/\bsignet\s*x\b/]],
      ['vx-pro4', 'VX-Pro4', [/\bvx\s*pro\s*4\b/]],
      ['xd-4', 'XD-4', [/\bxd\s*4\b/]],
      ['xd-5', 'XD-5', [/\bxd\s*5\b/]],
      ['astral-x', 'Astral-X', [/\bastral\s*x\b/]],
      ['dt-x', 'DT-X', [/\bdt\s*x\b/]],
      ['rx-7v', 'RX-7V', [/\brx\s*7v\b/]],
      ['sz-r-vas', 'SZ-R VAS', [/\bsz\s*r\s+vas\b/]],
      ['tour-x4', 'Tour-X4', [/\btour\s*x\s*4\b/]],
      ['vector-2', 'Vector-2', [/\bvector\s*2\b/]]
    ],
    'alpinestar-helmets': [
      ['s-m3', 'S-M3', [/\bs\s*m\s*3\b/]],
      ['s-m5', 'S-M5', [/\bs\s*m\s*5\b/]],
      ['s-m7', 'S-M7', [/\bs\s*m\s*7\b/]],
      ['supertech-m8', 'Supertech M8', [/\bsupertech\s+m\s*8\b/]],
      ['supertech-m10', 'Supertech M10', [/\bsupertech\s+m\s*10\b/]],
      ['supertech-r10', 'Supertech R10', [/\bsupertech\s+r\s*10\b/]]
    ],
    'hjc-helmets': [
      ['c10', 'C10', [/\bc\s*10\b/]],
      ['c20', 'C20', [/\bc\s*20\b/]],
      ['c50', 'C50', [/\bc\s*50\b/]],
      ['c70', 'C70', [/\bc\s*70\b/]],
      ['c71', 'C71', [/\bc\s*71\b/]],
      ['c90', 'C90', [/\bc\s*90\b/]],
      ['c91', 'C91', [/\bc\s*91\b/]],
      ['cl-x7-plus', 'CL-X7 Plus', [/\bcl\s*x\s*7\s+plus\b/]],
      ['cl-x7', 'CL-X7', [/\bcl\s*x\s*7\b/]],
      ['cl-xy-ii', 'CL-XY II', [/\bcl\s*xy\s*(?:ii|2)\b/]],
      ['cs-r3', 'CS-R3', [/\bcs\s*r\s*3\b/]],
      ['ds-x1', 'DS-X1', [/\bds\s*x\s*1\b/]],
      ['f31', 'F31', [/\bf\s*31\b/]],
      ['f70', 'F70', [/\bf\s*70\b/]],
      ['f71', 'F71', [/\bf\s*71\b/]],
      ['f100', 'F100', [/\bf\s*100\b/]],
      ['fg-jet', 'FG-Jet', [/\bfg\s*jet\b/]],
      ['i10', 'i10', [/\bi\s*10\b/]],
      ['i11', 'i11', [/\bi\s*11\b/]],
      ['i20n', 'i20N', [/\bi\s*20n\b/]],
      ['i20', 'i20', [/\bi\s*20\b/]],
      ['i30', 'i30', [/\bi\s*30\b/]],
      ['i31', 'i31', [/\bi\s*31\b/]],
      ['i40', 'i40', [/\bi\s*40\b/]],
      ['i50', 'i50', [/\bi\s*50\b/]],
      ['i70', 'i70', [/\bi\s*70\b/]],
      ['i71', 'i71', [/\bi\s*71\b/]],
      ['i80', 'i80', [/\bi\s*80\b/]],
      ['i90', 'i90', [/\bi\s*90\b/]],
      ['i91', 'i91', [/\bi\s*91\b/]],
      ['i100', 'i100', [/\bi\s*100\b/]],
      ['is-cruiser', 'IS-Cruiser', [/\bis\s*cruiser\b/]],
      ['rpha-1n-v2', 'RPHA 1N V2', [/\brpha\s*1n\s+v\s*2\b/]],
      ['rpha-1n', 'RPHA 1N', [/\brpha\s*1n\b/]],
      ['rpha-1', 'RPHA 1', [/\brpha\s*1(?![0-9a-z])\b/]],
      ['rpha-11-pro', 'RPHA 11 Pro', [/\brpha\s*11\s+pro\b/]],
      ['rpha-12n', 'RPHA 12N', [/\brpha\s*12n\b/]],
      ['rpha-12', 'RPHA 12', [/\brpha\s*12(?![0-9a-z])\b/]],
      ['rpha-31', 'RPHA 31', [/\brpha\s*31\b/]],
      ['rpha-60', 'RPHA 60', [/\brpha\s*60\b/]],
      ['rpha-70-st', 'RPHA 70 ST', [/\brpha\s*70\s+st\b/]],
      ['rpha-71', 'RPHA 71', [/\brpha\s*71\b/]],
      ['rpha-72', 'RPHA 72', [/\brpha\s*72\b/]],
      ['rpha-90s', 'RPHA 90S', [/\brpha\s*90s\b/]],
      ['rpha-91', 'RPHA 91', [/\brpha\s*91\b/]],
      ['rpha-x', 'RPHA X', [/\brpha\s*x\b/]],
      ['v10', 'V10', [/\bv\s*10\b/]],
      ['v31', 'V31', [/\bv\s*31\b/]],
      ['v60', 'V60', [/\bv\s*60\b/]],
      ['y10', 'Youth Y10', [/\byouth\s+y\s*10\b/, /\by\s*10\b/]]
    ],
    'icon-helmets': [
      ['airflite', 'Airflite', [/\bairflite\b/]],
      ['airform', 'Airform', [/\bairform\b/]],
      ['airframe-pro', 'Airframe Pro', [/\bairframe\s+pro\b/]],
      ['domain', 'Domain', [/\bdomain\b/]],
      ['elsinore', 'Elsinore', [/\belsinore\b/]],
      ['threshold', 'Threshold', [/\bthreshold\b/]],
      ['ultraflite', 'Ultraflite', [/\bultraflite\b/]],
      ['variant-pro', 'Variant Pro', [/\bvariant\s+pro\b/]]
    ],
    'z1r-helmets': [
      ['cc-beanie', 'CC Beanie', [/\bcc\s+beanie\b/]],
      ['child-rise', 'Child Rise', [/\bchild\s+rise\b/]],
      ['drifter', 'Drifter', [/\bdrifter\b/]],
      ['jackal', 'Jackal', [/\bjackal\b/]],
      ['jimmy', 'Jimmy', [/\bjimmy\b/]],
      ['nemesis', 'Nemesis', [/\bnemesis\b/]],
      ['nomad', 'Nomad', [/\bnomad\b/]],
      ['range-2', 'Range 2.0', [/\brange\s*2(?:\s*0)?\b/]],
      ['range', 'Range', [/\brange\b/]],
      ['rise-2', 'Rise 2.0', [/\brise\s*2(?:\s*0)?\b/]],
      ['youth-rise', 'Youth Rise', [/\byouth\s+rise\b/]],
      ['rise', 'Rise', [/\brise\b/]],
      ['road-maxx-2', 'Road Maxx 2.0', [/\broad\s+maxx\s*2(?:\s*0)?\b/]],
      ['road-maxx', 'Road Maxx', [/\broad\s+maxx\b/]],
      ['saturn-sv', 'Saturn SV', [/\bsaturn\s+sv\b/]],
      ['saturn', 'Saturn', [/\bsaturn\b/]],
      ['solaris-2', 'Solaris 2.0', [/\bsolaris\s*2(?:\s*0)?\b/]],
      ['solaris', 'Solaris', [/\bsolaris\b/]],
      ['vagrant-nc', 'Vagrant NC', [/\bvagrant\s+nc\b/]],
      ['vagrant', 'Vagrant', [/\bvagrant\b/]],
      ['youth-warrant-2', 'Youth Warrant 2.0', [/\byouth\s+warrant\s*2(?:\s*0)?\b/]],
      ['youth-warrant', 'Youth Warrant', [/\byouth\s+warrant\b/]],
      ['warrant-2', 'Warrant 2.0', [/\bwarrant\s*2(?:\s*0)?\b/]],
      ['warrant', 'Warrant', [/\bwarrant\b/]]
    ]
  };

  class P4MHelmetModelBrowser extends HTMLElement {
    connectedCallback() {
      if (this.dataset.p4mReady === 'true') return;
      this.dataset.p4mReady = 'true';

      this.abortController = new AbortController();
      this.collectionRoot = this.closest('results-list') || document;
      this.grid = this.collectionRoot.querySelector('ul.product-grid');
      this.status = this.querySelector('[data-p4m-helmet-load-status]');
      this.handleClick = (event) => {
        const link = event.target.closest('[data-p4m-helmet-model-link]');
        if (link && this.contains(link)) this.navigateToModel(event, link);
      };
      this.addEventListener('click', this.handleClick);

      if (window.location.hash) this.activateHash(window.location.hash);

      if (this.grid && this.dataset.p4mHelmetFragmentPath) {
        this.loadFullCatalog();
      } else {
        this.showFallbackStatus();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.handleClick) this.removeEventListener('click', this.handleClick);
    }

    async loadFullCatalog() {
      this.setAttribute('aria-busy', 'true');

      try {
        const firstFragment = await this.fetchFragment(1);
        const totalPages = Math.max(
          1,
          Number.parseInt(firstFragment.dataset.pages || '1', 10)
        );
        const fragments = [firstFragment];

        for (let firstPage = 2; firstPage <= totalPages; firstPage += 3) {
          const pageBatch = [];
          for (
            let page = firstPage;
            page < firstPage + 3 && page <= totalPages;
            page += 1
          ) {
            pageBatch.push(this.fetchFragment(page));
          }
          fragments.push(...(await Promise.all(pageBatch)));
        }

        this.renderFullCatalog(fragments);
      } catch (error) {
        if (error?.name !== 'AbortError') {
          console.warn('P4M helmet catalog kept its server-rendered fallback.', error);
          this.showFallbackStatus();
        }
      } finally {
        this.setAttribute('aria-busy', 'false');
      }
    }

    async fetchFragment(page) {
      const url = this.fragmentUrl(page);
      let latestError;

      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.abortController.signal
          });

          if (!response.ok) {
            throw new Error(`Helmet catalog request failed with ${response.status}.`);
          }

          const documentFragment = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );
          const fragment = documentFragment.querySelector(
            '[data-p4m-helmet-all-fragment]'
          );

          if (!fragment) {
            throw new Error('The helmet catalog response was incomplete.');
          }

          return fragment;
        } catch (error) {
          latestError = error;
          if (error?.name === 'AbortError' || attempt === 1) throw error;
          await new Promise((resolve) => window.setTimeout(resolve, 450));
        }
      }

      throw latestError;
    }

    fragmentUrl(page) {
      const url = new URL(this.dataset.p4mHelmetFragmentPath, window.location.origin);
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.forEach((value, key) => {
        if (key === 'sort_by' || key.startsWith('filter.')) {
          url.searchParams.append(key, value);
        }
      });

      url.searchParams.set('view', 'p4m-helmet-all');
      url.searchParams.set('page', String(page));
      return url.toString();
    }

    renderFullCatalog(fragments) {
      const expectedTotal = Number.parseInt(fragments[0].dataset.total || '0', 10);
      const cardsByProduct = new Map();

      fragments.forEach((fragment) => {
        fragment
          .querySelectorAll('[data-p4m-helmet-fragment-card]')
          .forEach((card) => {
            const productId = card.dataset.productId;
            if (productId && !cardsByProduct.has(productId)) {
              cardsByProduct.set(productId, card);
            }
          });
      });

      if (
        cardsByProduct.size === 0 ||
        (expectedTotal > 0 && cardsByProduct.size !== expectedTotal)
      ) {
        throw new Error(
          `Expected ${expectedTotal} helmet products but received ${cardsByProduct.size}.`
        );
      }

      const groups = new Map();
      cardsByProduct.forEach((card) => {
        const classification = this.classifyCard(card);
        if (!groups.has(classification.key)) {
          groups.set(classification.key, {
            cards: [],
            key: classification.key,
            label: classification.label,
            priority: classification.priority
          });
        }
        groups.get(classification.key).cards.push(card);
      });

      const sortedGroups = Array.from(groups.values()).sort((left, right) => {
        if (left.priority !== right.priority) return left.priority - right.priority;
        return left.label.localeCompare(right.label, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      });

      const gridContent = document.createDocumentFragment();
      sortedGroups.forEach((group) => {
        gridContent.append(this.modelHeading(group));
        group.cards.forEach((card) => gridContent.append(card));
      });

      this.grid.replaceChildren(gridContent);
      this.grid.dataset.lastPage = '1';
      this.grid.dataset.p4mHelmetComplete = 'true';
      this.rebuildNavigation(sortedGroups);
      this.removePagination();

      if (this.status) {
        const noun = cardsByProduct.size === 1 ? 'product is' : 'products are';
        this.status.textContent =
          `All ${cardsByProduct.size} ${noun} organized by helmet model below.`;
      }

      if (window.location.hash) this.activateHash(window.location.hash);
    }

    classifyCard(card) {
      const handle = this.dataset.p4mHelmetCollectionHandle || '';
      const rules = P4M_HELMET_MODEL_RULES[handle] || [];
      const text = this.normalizeText(
        [
          card.dataset.p4mHelmetTitle,
          card.dataset.p4mHelmetProductType,
          card.dataset.p4mHelmetTags
        ].join(' ')
      );
      const matches = rules.filter(([, , patterns]) =>
        patterns.some((pattern) => pattern.test(text))
      );
      const accessory = this.isAccessory(text);

      if (matches.length > 1 && accessory) {
        return {
          key: 'multi-model-parts',
          label: 'Multi-model Parts & Accessories',
          priority: 80
        };
      }

      if (matches.length > 0) {
        return {
          key: matches[0][0],
          label: matches[0][1],
          priority: 10
        };
      }

      if (accessory) {
        return {
          key: 'helmet-parts-accessories',
          label: 'Helmet Parts & Accessories',
          priority: 90
        };
      }

      return {
        key: 'other-helmets',
        label: `Other ${this.dataset.p4mHelmetBrand || ''} Helmets`.trim(),
        priority: 95
      };
    }

    normalizeText(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[®™]/g, '')
        .replace(/[-_/|]+/g, ' ')
        .replace(/[^a-z0-9.' ]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    isAccessory(text) {
      return /\b(accessor|bag|breath|cheek|chin\s+(?:curtain|vent)|ear\s+pad|face\s*shield|helmet\s+holder|interior|lens|liner|neck\s+roll|pad|pinlock|pivot|pod|proshade|replacement|screw|shield|spoiler|t\s*shirt|top\s+vent|visor)\b/.test(
        text
      );
    }

    modelHeading(group) {
      const heading = document.createElement('li');
      heading.className = 'p4m-brand-section-heading p4m-helmet-model-section';
      heading.id = this.modelTargetId(group.key);
      heading.dataset.p4mHelmetModelSection = '';

      const eyebrow = document.createElement('span');
      eyebrow.className = 'p4m-brand-section-heading__eyebrow';
      eyebrow.textContent = group.priority < 80 ? 'Helmet model' : 'Accessories';

      const title = document.createElement('span');
      title.className = 'p4m-brand-section-heading__title';
      title.textContent = group.label;

      const count = document.createElement('span');
      count.className = 'p4m-brand-section-heading__count';
      count.textContent = `${group.cards.length} ${
        group.cards.length === 1 ? 'product' : 'products'
      }`;

      heading.append(eyebrow, title, count);
      return heading;
    }

    rebuildNavigation(groups) {
      const navigation = this.querySelector('.p4m-helmet-model-browser__list');
      if (!navigation) return;

      const links = document.createDocumentFragment();
      groups.forEach((group) => {
        const link = document.createElement('a');
        link.href = `#${this.modelTargetId(group.key)}`;
        link.dataset.p4mHelmetModelLink = '';

        const label = document.createElement('span');
        label.textContent = group.label;

        const count = document.createElement('b');
        count.textContent = String(group.cards.length);

        link.append(label, count);
        links.append(link);
      });

      navigation.replaceChildren(links);
    }

    modelTargetId(modelKey) {
      return `p4m-helmet-model-${modelKey}-${
        this.dataset.p4mHelmetSectionId || 'collection'
      }`;
    }

    removePagination() {
      this.collectionRoot
        .querySelectorAll(
          '.p4m-fitment-pagination, [ref="viewMoreNext"], [ref="viewMorePrevious"]'
        )
        .forEach((element) => element.remove());
    }

    showFallbackStatus() {
      if (!this.status) return;
      const visibleProducts = this.grid
        ? this.grid.querySelectorAll('[data-product-id]').length
        : 0;
      this.status.textContent = `Showing ${visibleProducts || 'the available'} products.`;
    }

    navigateToModel(event, link) {
      const targetId = link.hash ? decodeURIComponent(link.hash.slice(1)) : '';
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      event.preventDefault();
      this.setActiveLink(link);

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const headerOffset = window.matchMedia('(max-width: 749px)').matches ? 88 : 108;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.history.replaceState(null, '', `#${targetId}`);
      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    activateHash(hash) {
      const link = Array.from(
        this.querySelectorAll('[data-p4m-helmet-model-link]')
      ).find((candidate) => candidate.hash === hash);
      if (link) this.setActiveLink(link);
    }

    setActiveLink(activeLink) {
      this.querySelectorAll('[data-p4m-helmet-model-link]').forEach((link) => {
        const selected = link === activeLink;
        link.classList.toggle('is-active', selected);
        if (selected) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('p4m-helmet-model-browser', P4MHelmetModelBrowser);
}
